module.exports = __webpack_public_path__ + "img/icon-dclshgz1.a16e12df.png";